/* tslint:disable */
/* eslint-disable */
/**
 * Sds Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PreviewSurfaceLayoutsResponse
 */
export interface PreviewSurfaceLayoutsResponse {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PreviewSurfaceLayoutsResponse
     */
    activeLayouts: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof PreviewSurfaceLayoutsResponse
     */
    configString: string;
}

export function PreviewSurfaceLayoutsResponseFromJSON(json: any): PreviewSurfaceLayoutsResponse {
    return PreviewSurfaceLayoutsResponseFromJSONTyped(json, false);
}

export function PreviewSurfaceLayoutsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreviewSurfaceLayoutsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'activeLayouts': json['activeLayouts'],
        'configString': json['configString'],
    };
}

export function PreviewSurfaceLayoutsResponseToJSON(value?: PreviewSurfaceLayoutsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'activeLayouts': value.activeLayouts,
        'configString': value.configString,
    };
}


